import { render, staticRenderFns } from "./m-latestBlocks.vue?vue&type=template&id=52075abd&scoped=true&"
import script from "./m-latestBlocks.vue?vue&type=script&lang=ts&"
export * from "./m-latestBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./m-latestBlocks.vue?vue&type=style&index=0&id=52075abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52075abd",
  null
  
)

export default component.exports